import { useLang } from "./LangContext";
import { ChapterHead, FadeUp } from "./Reveal";

export default function Experience() {
  const { t } = useLang();
  const e = t.experience;

  return (
    <section id="deneyim" className="section" data-testid="experience-section">
      <div className="wrap">
        <ChapterHead num={e.num} label={e.label} title={e.title} lead={e.lead} />
        <div className="exp-grid">
          <FadeUp>
            <div className="frame exp-media" data-testid="experience-media">
              <img src="/img/venue-friends.jpg" alt={e.imgAlt} loading="lazy" decoding="async" />
              <div className="frame-veil" aria-hidden="true" />
              <p className="strip-caption">
                <span className="diamond" aria-hidden="true">◆</span>
                {e.imgCaption}
              </p>
            </div>
          </FadeUp>
          <div className="exp-list">
            {e.items.map((item, i) => (
              <FadeUp key={item.title} delay={i * 0.05}>
                <div className="exp-item" data-testid={`experience-item-${i}`}>
                  <span className="idx" aria-hidden="true">
                    {String(i + 1).padStart(2, "0")}
                  </span>
                  <div>
                    <h3>{item.title}</h3>
                    <p>{item.text}</p>
                  </div>
                </div>
              </FadeUp>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
